<div class="home-page-container">
  <div class="app-gutters list-page-gutters" *ngIf="loading === false; else isLoading">
    <header *ngIf="showListPage">
      <div class="user" *ngIf="userFullName" data-e2e="CustomerLandingPage_WelcomeMessage" data-pii>
        {{ pageTitle }}
      </div>
    </header>
    <div *ngIf="showPopUpPage">
      <app-acceptence-page
        [hasRecords]="hasTermsRecords"
        [termsConditions]="termsConditionsAccepted"
        [electronicConsent]="electronicConsentAccepted"
        (isDone)="doneAcceptence()"
        (logout)="logout()">
      </app-acceptence-page>
    </div>
    <div *ngIf="showListPage===true">
      <ng-container>
        <dxo-card [bodyHeader]="bodyHeader">
          <card-body>
            <div class="loader-container" *ngIf="(data$ | async) === null">
              <dxo-circular-loader text="Loading..." [size]="'large'" [color]="'blue'"></dxo-circular-loader>
            </div>
            <div *ngIf="(policyNumbers$ | async)! > 1">
              <div *ngIf="hasPolicies$ | async">
                <dxo-table
                  *ngIf="data$ | async as data"
                  class="sum-table"
                  [stickyColumn]="false"
                  [data]="data"
                  [dxoDataset]="[{ selector: 'tbody tr', data: { e2e: 'policy-row' } }]"
                ></dxo-table>
              </div>
            </div>
            <app-empty-results
              *ngIf="(hasPolicies$ | async) === false && (data$ | async) !== null"
              header="No policies found"
            >
              <empty-results-text>
                <div class="heading-sm empty-results-text">You have no policies on record.</div>
              </empty-results-text>
            </app-empty-results>
          </card-body>
        </dxo-card>
      </ng-container>
    </div>
  </div>
  <ng-template #isLoading>
    <div class="top-level-loader">
      <dxo-circular-loader [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
    </div>
  </ng-template>
</div>
